(function () {

  /* =========================================
     FECHA ACTUAL DE GUATEMALA
     ========================================= */

  function getGuatemalaToday() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Guatemala',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const year = Number(parts.find(p => p.type === 'year').value);
    const month = Number(parts.find(p => p.type === 'month').value);
    const day = Number(parts.find(p => p.type === 'day').value);

    return new Date(year, month - 1, day);
  }


  function sameDate(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }


  /* =========================================
     SEMANA SANTA AUTOMÁTICA
     ========================================= */

  function getEasterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);

    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day);
  }


  /* =========================================
     FERIADOS TRASLADABLES
     1 mayo, 30 junio y 20 octubre
     ========================================= */

  function getObservedHoliday(year, month, day) {
    const date = new Date(year, month, day);
    const weekday = date.getDay();

    /*
      Si cae martes o miércoles:
      se goza lunes anterior.
    */
    if (weekday === 2) {
      date.setDate(date.getDate() - 1);
    }

    if (weekday === 3) {
      date.setDate(date.getDate() - 2);
    }

    /*
      Si cae jueves, viernes, sábado o domingo:
      se goza lunes siguiente.
    */
    if (weekday === 4) {
      date.setDate(date.getDate() + 4);
    }

    if (weekday === 5) {
      date.setDate(date.getDate() + 3);
    }

    if (weekday === 6) {
      date.setDate(date.getDate() + 2);
    }

    if (weekday === 0) {
      date.setDate(date.getDate() + 1);
    }

    return date;
  }


  /* =========================================
     DÍAS EN LOS QUE NO SE ENTREGA
     ========================================= */

  function isNonWorkingDay(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();


    /* Domingo */
    if (date.getDay() === 0) {
      return true;
    }


    /* 1 de enero */
    if (month === 0 && day === 1) {
      return true;
    }


    /* 15 de septiembre */
    if (month === 8 && day === 15) {
      return true;
    }


    /* 1 de noviembre */
    if (month === 10 && day === 1) {
      return true;
    }


    /* 24 de diciembre - Dingo no trabaja */
    if (month === 11 && day === 24) {
      return true;
    }


    /* 25 de diciembre */
    if (month === 11 && day === 25) {
      return true;
    }


    /* 31 de diciembre - Dingo no trabaja */
    if (month === 11 && day === 31) {
      return true;
    }


    /*
      Feriados trasladables:
      1 mayo
      30 junio
      20 octubre
    */

    const may1 =
      getObservedHoliday(year, 4, 1);

    const june30 =
      getObservedHoliday(year, 5, 30);

    const october20 =
      getObservedHoliday(year, 9, 20);


    if (
      sameDate(date, may1) ||
      sameDate(date, june30) ||
      sameDate(date, october20)
    ) {
      return true;
    }


    /* =====================================
       SEMANA SANTA
       Jueves a domingo no se trabaja
       ===================================== */

    const easter =
      getEasterSunday(year);


    const holyThursday =
      new Date(easter);

    holyThursday.setDate(
      easter.getDate() - 3
    );


    const goodFriday =
      new Date(easter);

    goodFriday.setDate(
      easter.getDate() - 2
    );


    const holySaturday =
      new Date(easter);

    holySaturday.setDate(
      easter.getDate() - 1
    );


    if (
      sameDate(date, holyThursday) ||
      sameDate(date, goodFriday) ||
      sameDate(date, holySaturday) ||
      sameDate(date, easter)
    ) {
      return true;
    }


    return false;
  }


  /* =========================================
     SUMAR DÍAS VÁLIDOS DE ENTREGA
     ========================================= */

  function addDeliveryDays(baseDate, days) {
    const date = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate()
    );

    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      if (!isNonWorkingDay(date)) {
        added++;
      }
    }

    return date;
  }


  const weekdays = [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado'
  ];


  const months = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre'
  ];


  function isTomorrow(date, today) {
    const tomorrow = new Date(today);

    tomorrow.setDate(
      tomorrow.getDate() + 1
    );

    return sameDate(date, tomorrow);
  }


  function formatDate(date, today, showMonth) {
    let result = '';

    if (isTomorrow(date, today)) {
      result += 'mañana ';
    }

    result +=
      weekdays[date.getDay()] +
      ' ' +
      date.getDate();

    if (showMonth) {
      result +=
        ' de ' +
        months[date.getMonth()];
    }

    return result;
  }


  /* =========================================
     MODIFICAR EL RECUADRO AMARILLO REAL
     ========================================= */

  function updateDeliveryElement(element) {
    if (!element) return;

    if (
      element.dataset.dingoDeliveryReady === 'true'
    ) {
      return;
    }


    const rawText =
      (element.textContent || '').trim();


    /*
      Detecta:
      1-2 días hábiles
      1–2 días hábiles
      2-4 días hábiles
      etc.
    */

    const match =
      rawText.match(
        /(\d+)\s*(?:-|–|—|a)\s*(\d+)/i
      );


    if (!match) {
      return;
    }


    const minDays =
      Number(match[1]);

    const maxDays =
      Number(match[2]);


    const today =
      getGuatemalaToday();


    const startDate =
      addDeliveryDays(
        today,
        minDays
      );


    const endDate =
      addDeliveryDays(
        today,
        maxDays
      );


    const sameMonth =
      startDate.getFullYear() ===
        endDate.getFullYear() &&
      startDate.getMonth() ===
        endDate.getMonth();


    const startText =
      formatDate(
        startDate,
        today,
        !sameMonth
      );


    const endText =
      formatDate(
        endDate,
        today,
        true
      );


    const newText =
      'Recíbelo entre ' +
      startText +
      ' y ' +
      endText;


    /*
      El icono del camión es un SVG.
      No queremos borrarlo.

      Buscamos solamente el nodo de texto
      "1-2 días hábiles" y lo sustituimos.
    */

    let textNodeFound = false;


    Array.from(element.childNodes).forEach(function (node) {

      if (
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim() !== ''
      ) {

        node.textContent =
          ' ' + newText;

        textNodeFound = true;
      }

    });


    /*
      Por si el tema cambia la estructura
      y no encontramos un nodo directo.
    */

    if (!textNodeFound) {

      const svg =
        element.querySelector('svg');

      element.innerHTML = '';

      if (svg) {
        element.appendChild(svg);
      }

      element.appendChild(
        document.createTextNode(
          ' ' + newText
        )
      );
    }


    element.dataset.dingoDeliveryReady =
      'true';
  }


  function updateAllDeliveryElements() {

    document
      .querySelectorAll(
        '.main_free_d, .main_selling_f'
      )
      .forEach(
        updateDeliveryElement
      );
  }


  function initDingoDelivery() {

    updateAllDeliveryElements();


    setTimeout(
      updateAllDeliveryElements,
      300
    );


    setTimeout(
      updateAllDeliveryElements,
      1000
    );


    const observer =
      new MutationObserver(function () {

        updateAllDeliveryElements();

      });


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initDingoDelivery,
      { once: true }
    );

  } else {

    initDingoDelivery();

  }

})();

/* ==================================================
   ORDEN MÓVIL ESTILO AMAZON - DINGO
   ================================================== */

(function () {

  const mobileQuery =
    window.matchMedia('(max-width: 767px)');

  let updatingLayout = false;


  function createOriginMarker(element, name) {

    if (!element || !element.parentNode) {
      return null;
    }

    let marker =
      document.querySelector(
        '[data-dingo-origin="' + name + '"]'
      );

    if (!marker) {

      marker =
        document.createElement('span');

      marker.hidden = true;

      marker.dataset.dingoOrigin =
        name;

      element.parentNode.insertBefore(
        marker,
        element
      );
    }

    return marker;
  }


  function moveMobileProductInfo() {

    if (updatingLayout) return;

    updatingLayout = true;

    try {

      const productInfo =
        document.querySelector(
          'product-info .product__info-container'
        );

      if (!productInfo) return;


      const buyBox =
        productInfo.querySelector(
          '.qty_price_buy'
        );

      if (!buyBox) return;


      const priceQuantity =
        buyBox.querySelector(
          '.pro_qty_price'
        );

      if (!priceQuantity) return;


      /* =========================
         PRECIO
         ========================= */

      const mainPrice =
        priceQuantity.querySelector(
          '.main__price'
        );

      if (
        mainPrice &&
        mainPrice.parentElement
      ) {

        mainPrice.parentElement
          .classList.add(
            'dingo-mobile-price-block'
          );

          /* ¿Cómo comprar? debajo del precio */

const videoButton =
  buyBox.querySelector('.dingo-video-btn');

if (
  videoButton &&
  !priceQuantity.contains(videoButton)
) {

  createOriginMarker(
    videoButton,
    'video'
  );

  const priceBlock =
    priceQuantity.querySelector(
      '.dingo-mobile-price-block'
    );

  if (priceBlock) {
    priceBlock.insertAdjacentElement(
      'afterend',
      videoButton
    );
  }
}

      }


      /* =========================
         ENTREGA ESTIMADA
         ========================= */

      const delivery =
        productInfo.querySelector(
          '.main_free'
        );

      if (
        delivery &&
        !priceQuantity.contains(delivery)
      ) {

        createOriginMarker(
          delivery,
          'delivery'
        );

        delivery.classList.add(
          'dingo-mobile-delivery'
        );

        priceQuantity.appendChild(
          delivery
        );

      }


      /* =========================
         DISPONIBILIDAD
         ========================= */

      const inventory =
        productInfo.querySelector(
          '.product__inventory'
        );

      if (
        inventory &&
        !priceQuantity.contains(inventory)
      ) {

        createOriginMarker(
          inventory,
          'inventory'
        );

        inventory.classList.add(
          'dingo-mobile-inventory'
        );

        priceQuantity.appendChild(
          inventory
        );

      }

    } finally {

      updatingLayout = false;

    }
  }


  function restoreDesktopProductInfo() {

    if (updatingLayout) return;

    updatingLayout = true;

    try {

      const productInfo =
        document.querySelector(
          'product-info .product__info-container'
        );

      if (!productInfo) return;


      /* Restaurar entrega */

      const delivery =
        productInfo.querySelector(
          '.dingo-mobile-delivery'
        );

      const deliveryMarker =
        productInfo.querySelector(
          '[data-dingo-origin="delivery"]'
        );

      if (
        delivery &&
        deliveryMarker
      ) {

        deliveryMarker.after(
          delivery
        );

        delivery.classList.remove(
          'dingo-mobile-delivery'
        );

        deliveryMarker.remove();

      }


      /* Restaurar disponibilidad */

      const inventory =
        productInfo.querySelector(
          '.dingo-mobile-inventory'
        );

      const inventoryMarker =
        productInfo.querySelector(
          '[data-dingo-origin="inventory"]'
        );

      if (
        inventory &&
        inventoryMarker
      ) {

        inventoryMarker.after(
          inventory
        );

        inventory.classList.remove(
          'dingo-mobile-inventory'
        );

        inventoryMarker.remove();

      }


      productInfo
        .querySelectorAll(
          '.dingo-mobile-price-block'
        )
        .forEach(function (element) {

          element.classList.remove(
            'dingo-mobile-price-block'
          );

        });

    } finally {

      updatingLayout = false;

    }
  }


  function updateProductLayout() {

    if (mobileQuery.matches) {

      moveMobileProductInfo();

    } else {

      restoreDesktopProductInfo();

    }

  }


  /* Primera carga */

  updateProductLayout();


  document.addEventListener(
    'DOMContentLoaded',
    updateProductLayout
  );


  /* Al girar teléfono o cambiar tamaño */

  if (mobileQuery.addEventListener) {

    mobileQuery.addEventListener(
      'change',
      updateProductLayout
    );

  } else {

    mobileQuery.addListener(
      updateProductLayout
    );

  }


  /*
    Shopify puede actualizar el producto
    cuando se cambia una variante.
  */

  const productInfo =
    document.querySelector(
      'product-info'
    );

  if (productInfo) {

    const observer =
      new MutationObserver(function () {

        requestAnimationFrame(
          updateProductLayout
        );

      });

    observer.observe(
      productInfo,
      {
        childList: true,
        subtree: true
      }
    );

  }

})();

/* ==================================================
   PUNTOS DE GALERÍA MÓVIL - DINGO
   ================================================== */

(function () {

  function initDingoGalleryDots() {

    if (window.innerWidth > 767) return;

    document
      .querySelectorAll(
        '.product__media-wrapper slider-component'
      )
      .forEach(function (sliderComponent) {

        if (
          sliderComponent.dataset.dingoDotsReady === 'true'
        ) {
          return;
        }

        const slider =
          sliderComponent.querySelector(
            '.product__media-list'
          );

        if (!slider) return;

        const slides =
          Array.from(
            slider.querySelectorAll(
              '.product__media-item'
            )
          );

        if (slides.length <= 1) return;


        /* Crear contenedor */

        const dots =
          document.createElement('div');

        dots.className =
          'dingo-gallery-dots';


        slides.forEach(function (slide, index) {

          const dot =
            document.createElement('button');

          dot.type = 'button';

          dot.className =
            'dingo-gallery-dot';

          dot.setAttribute(
            'aria-label',
            'Ver imagen ' + (index + 1)
          );

          dot.textContent = '●';


          /* Estilo temporal */
          dot.style.border = '0';
          dot.style.background = 'transparent';
          dot.style.padding = '2px 4px';
          dot.style.fontSize = '12px';
          dot.style.lineHeight = '1';
          dot.style.cursor = 'pointer';
          dot.style.opacity =
            index === 0 ? '1' : '0.25';


          dot.addEventListener(
            'click',
            function () {

              const targetLeft =
                slide.offsetLeft -
                slider.offsetLeft;

              slider.scrollTo({
                left: targetLeft,
                behavior: 'smooth'
              });

            }
          );


          dots.appendChild(dot);

        });


        slider.insertAdjacentElement(
          'afterend',
          dots
        );


        /* Detectar qué foto está visible */

        let ticking = false;

        function updateDots() {

          const currentScroll =
            slider.scrollLeft;

          let closestIndex = 0;
          let closestDistance =
            Infinity;


          slides.forEach(
            function (slide, index) {

              const slidePosition =
                slide.offsetLeft -
                slider.offsetLeft;

              const distance =
                Math.abs(
                  slidePosition -
                  currentScroll
                );

              if (
                distance <
                closestDistance
              ) {

                closestDistance =
                  distance;

                closestIndex =
                  index;
              }

            }
          );


          dots
            .querySelectorAll(
              '.dingo-gallery-dot'
            )
            .forEach(
              function (dot, index) {

                dot.style.opacity =
                  index === closestIndex
                    ? '1'
                    : '0.25';

              }
            );

        }


        slider.addEventListener(
          'scroll',
          function () {

            if (!ticking) {

              window.requestAnimationFrame(
                function () {

                  updateDots();

                  ticking = false;

                }
              );

              ticking = true;
            }

          },
          { passive: true }
        );


        sliderComponent.dataset
          .dingoDotsReady =
          'true';

      });

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initDingoGalleryDots
    );

  } else {

    initDingoGalleryDots();

  }

})();